import http from '../../utils/http';
import store from '../../store/index';
import {
	Message
} from 'element-ui';

export default {
	/**
	 * 获取启用的卡类型
	 *
	 * @return {*}
	 */
	getEnabledCardCategory() {
		return http({
			url: 'evaluation/GetCardCategory'
		});
	},
	/**
	 * 获取用户测评次数信息
	 *
	 * @returns
	 */
	getUserEvaluation() {
		return http({
			url: 'evaluation',
			method: 'GET'
		});
	},
	/**
	 * 获取测评简介
	 *
	 * @param {*} data
	 * @returns
	 */
	getEvaluationDesc(data) {
		return http({
			url: 'evaluation',
			method: 'GET',
			params: data
		});
	},
	/**
	 * 获取测评题目
	 *
	 * @param {*} data
	 * @returns
	 */
	getEvaluationQuestion(data) {
		return http({
			url: 'evaluation/GetEvaluationQuestion',
			method: 'GET',
			params: data
		});
	},
	/**
	 * 保存测评
	 *
	 * @param {*} data
	 * @returns
	 */
	saveEvaluation(data) {
		if (!store.state.user.onSaveEvaluation) {
			return http({
				url: 'evaluation/SaveUserEvaluation',
				method: 'POST',
				data,
				headers: {
					notShowError: true,
					showLoading: false
				}
			}).then(res => {
				// store.dispatch('setOnSaveEvaluation', false);
				return Promise.resolve(res);
			}).catch(err => {
				// store.dispatch('setOnSaveEvaluation', false);
				return Promise.reject(err);
			});
		} else {
			Message.closeAll();
			Message({
				message: '请勿重复请求',
				type: 'error',
				duration: 3 * 1000,
				showClose: true
			});
			return Promise.reject(new Error('请勿重复请求'));
		}
	},
	/**
	 * 获取我的报告
	 *
	 * @param {*} data
	 * @returns
	 */
	getMyReport(data) {
		return http({
			url: 'evaluation/GetMyReport',
			method: 'GET',
			params: data
		});
	},
	/**
	 * 重新生成pdf
	 *
	 * @param {*} data
	 * @return {*}
	 */
	reCreatePdf(data) {
		return http({
			url: 'evaluation/ReCreatePDF',
			params: data,
			method: 'PUT'
		});
	}
};
